module.exports = __webpack_public_path__ + "img/tupian.eff9033e.png";